import { mapMutations, mapGetters } from 'vuex';
import { union } from 'lodash';

import { renderFormulas } from '@/helpers/functions';
import ContentType from '@/helpers/contentType';
import CategoryType from '@/helpers/contentCategory';
import { getParentOfSelectedTopic } from '@/helpers/tree';

import Editor from '@/components/content-management/editor-container';
import HtmlRenderContainer from '@/components/content-management/html-render-container';

import TaskEditor from '@/components/content-management/task/editor';
import TaskRender from '@/components/content-management/task/render/teacher';
import LTIRender from '@/components/content-management/lti/wrapper-render';

import ConferenceRender from '@/components/content-management/webconference/render/teacher';
import linkGroupEditor from '@grupoa/know-more';
import LinkGroupRender from '@/components/content-management/link-group-render-container';
import ForumPreview from '@/components/gaia/modals/forum-preview';
import QuizRender from '@/components/content-management/quiz/render/teacher';
import ConfirmEditModal from '@/components/gaia/modals/confirm-edit';

const renders = {
  [CategoryType.HTML]                : HtmlRenderContainer,
  [CategoryType.DISCURSIVE_EXERCISE] : TaskRender,
  [CategoryType.LINKS]               : LinkGroupRender,
  [CategoryType.FORUM]               : ForumPreview,
  [CategoryType.WEBCONFERENCE]       : ConferenceRender,
  [CategoryType.LTI]                 : LTIRender,
  [CategoryType.EXERCISE]            : QuizRender
};

const editors = {
  [CategoryType.HTML]                : Editor,
  [CategoryType.DISCURSIVE_EXERCISE] : TaskEditor,
  [CategoryType.LINKS]               : linkGroupEditor,
  [CategoryType.WEBCONFERENCE]       : ConferenceRender,
  [CategoryType.LTI]                 : LTIRender,
  [CategoryType.EXERCISE]            : QuizRender
};

export default {
  components: {
    Editor,
    TaskRender,
    linkGroupEditor,
    LinkGroupRender,
    ConferenceRender,
    ConfirmEditModal
  },
  data() {
    return {
      isEditing           : false,
      isEditable          : false,
      confirmModalOptions : {
        isOpen            : false,
        marketplaceAuthor : null
      }
    };
  },
  props    : ['items', 'styles', 'drag', 'academicMainId', 'academicMainTypeId'],
  computed : {
    ...mapGetters({
      getterMenuTopics: 'plataforma/content/getterMenuTopics'
    }),
    comp() {
      return this.isEditing ? editors[this.items.categoryTypeId] : renders[this.items.categoryTypeId];
    },
    props() {
      if (this.items.topicTypeId === ContentType.FORUM) {
        return {
          title   : this.items.title,
          content : { ...this.items.content, enrollmentIdsWhoLiked: this.items.enrollmentIdsWhoLiked }
        };
      } else if (this.items.topicTypeId === ContentType.LTI) {
        return {
          title   : this.items.title,
          content : {
            ...this.items.content,
            hasDeadline : this.items.hasDeadline,
            deadlineAt  : this.items.deadlineAt
          }
        };
      } else {
        return {
          title       : this.items.title,
          content     : this.items.content,
          configProps : {
            autoFocus     : false,
            isInline      : false,
            readOnly      : false,
            customToolbar : 'undo redo | formatselect | fontsizeselect | bold italic forecolor fontselect | alignleft aligncenter alignright alignjustify | bullist numlist outdent indent hr removeformat | customLink grupoaAttachment grupoaBook grupoaLayout grupoaInteractive grupoaAudio grupoaVideo recordVideo recordAudio | wirisMathType wirisChemType '
          },
          introCustomToolbar: 'undo redo | formatselect | fontsizeselect | bold italic underline backcolor forecolor fontselect | alignleft aligncenter alignright alignjustify | bullist numlist outdent indent hr | removeformat | emoticons | help'
        };
      }
    },
    contentTypeComputed() {
      return ContentType;
    }
  },
  methods: {
    ...mapMutations({
      SET_SELECTED_TOPIC_WITH_CONTENT: 'plataforma/content/SET_SELECTED_TOPIC_WITH_CONTENT'
    }),
    mouseOver() {
      // this.$nuxt.$emit('mouseOverSection');
    },
    mouseLeave() {
      // this.$nuxt.$emit('mouseLeaveSection');

      // this.isEditing = false;
    },
    addElement() {
      this.$emit('emitAddElement');
    },
    editItem() {
      if (this.items.topicTypeId === ContentType.FORUM) {
        this.emitEditForum();
      } else if (this.items.topicTypeId === ContentType.QUIZ) {
        this.emitOpenQuizModal();
      } else if (this.items.topicTypeId === ContentType.TASK) {
        this.emitEditTask();
      } else if (this.items.topicTypeId === ContentType.LTI) {
        this.$nuxt.$emit('management-section', {
          type : 'editLti',
          data : this.items
        });
      } else {
        if (!this.isEditing) {
          this.openConfirmEditModal();
        }

        if (!this.confirmModalOptions.isOpen) {
          this.isEditing = !this.isEditing;
        }
      }

      renderFormulas(this);
    },
    removeElement() {
      this.$nuxt.$emit('management-section', {
        type : 'deleteTopic',
        data : {
          ...this.items
        }
      });
    },
    showConfiguration() {
      const itemParent = this.items.parentTopicId && getParentOfSelectedTopic(this.getterMenuTopics, this.items);

      if (this.items.categoryTypeId === CategoryType.WEBCONFERENCE ||
        (
          this.items.categoryTypeId === CategoryType.HTML &&
          (this.items.parentTopicId === (itemParent && itemParent.id) &&
            (itemParent && itemParent.topicTypeId === ContentType.PAGE)
          )
        )
      ) {
        return true;
      }
      return false;
    },
    goToConfiguration() {
      this.$nuxt.$emit('changeSidebarTab', this.items);
    },
    changeTitleOfTopic(value) {
      this.$nuxt.$emit('management-section', {
        type : 'changeTopicTitle',
        data : {
          ...this.items,
          title: value
        }
      });
    },
    blurContent(value) {
      this.$nuxt.$emit('management-section', {
        type : 'blurContent',
        data : {
          ...this.items,
          content: value
        }
      });
    },
    emitChangeContent() {
      this.setEditedTopicId();

      this.$nuxt.$emit('management-section', {
        type: 'changeContent'
      });
    },
    linkGroupEvent(value) {
      this.setEditedTopicId();

      this.$nuxt.$emit('management-section', {
        type : 'eventLinkGroup',
        data : {
          ...this.items,
          content: {
            type         : value.type,
            modification : value.content
          }
        }
      });
    },
    linkGroupClick(value) {
      this.$nuxt.$emit('management-section', {
        type : 'clickLinkGroup',
        data : value
      });
    },
    emitForum() {
      this.$nuxt.$emit('management-section', {
        type : 'openForum',
        data : this.items
      });
    },
    rateForum() {
      this.$nuxt.$emit('management-section', {
        type : 'rateForum',
        data : this.items
      });
    },
    emitEditForum() {
      this.$nuxt.$emit('management-section', {
        type : 'editForum',
        data : this.items
      });
    },
    emitEditTask() {
      this.$nuxt.$emit('management-section', {
        type : 'editTask',
        data : this.items
      });
    },
    emitOpenQuizModal() {
      this.$nuxt.$emit('management-section', {
        type : 'openQuizModal',
        data : this.items
      });
    },
    openConfirmEditModal() {
      const parentItem = this.items.parentTopicId && getParentOfSelectedTopic(this.getterMenuTopics, this.items);

      if ((parentItem && parentItem.isMarketplace) || this.items.isMarketplace) {
        let editedTopicsArray = sessionStorage.getItem('edited_topics_ids');
        editedTopicsArray = editedTopicsArray ? JSON.parse(editedTopicsArray) : [];

        const hasEditedTopicContent = editedTopicsArray.length > 0 && editedTopicsArray.findIndex(topicId => topicId === this.items.id || topicId === parentItem?.id) > -1;

        if (!hasEditedTopicContent) {
          this.confirmModalOptions.marketplaceAuthor = this.items.marketplaceAuthor || parentItem.marketplaceAuthor;
          this.confirmModalOptions.isOpen = true;
        }
      }
    },
    resetConfirmModalOptions() {
      this.confirmModalOptions = {
        isOpen            : false,
        marketplaceAuthor : null
      };
    },
    confirmEditContent() {
      this.isEditing = true;
      this.resetConfirmModalOptions();
    },
    setEditedTopicId() {
      if (this.items.isMarketplace) {
        this.items.hasEditedContent = true;
        let editedTopicsIds = sessionStorage.getItem('edited_topics_ids');

        const newEditedTopics = [this.items.id];
        if (this.items.parentTopicId) {
          newEditedTopics.push(this.items.parentTopicId);
        }

        editedTopicsIds = editedTopicsIds ? union(JSON.parse(editedTopicsIds), newEditedTopics) : newEditedTopics;
        sessionStorage.setItem('edited_topics_ids', JSON.stringify(editedTopicsIds));
      }
    }
  }
};
